import React, { useEffect, useState } from 'react';
import {
  isEmpty,
  applyTruncationForAllScreen,
  applyTruncationForScreen,
  findValueByKey,
  isLinkAbsolute,
  correctInternalLink,
  getImage,
  stripHtml,
  removeNbsp,
  isItUndefined,
} from '../../util/DataUtil';
import { useRouter } from 'next/router';
import { Constants } from '../../util/Constants';
import Image from 'next/image';
import CtaBarButton from '../base/cta-bar-button';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';

export default function TemplateRelated({
  data,
  title,
  link,
  primaries,
  otherData,
}) {
  if (!data || data.length === 0 || isEmpty(data[0])) {
    return '';
  }

  const router = useRouter();
  const { asPath } = router;

  const [titles, setTitles] = useState([]);
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  if (
    data &&
    Object.keys(data).length === 0 &&
    Object.getPrototypeOf(data) === Object.prototype
  ) {
    return '';
  }

  const truncate = () => {
    const titles = data.map((item) => {
      const templateTitle = findValueByKey(
        'template_title_block_type',
        item?.field_template_blocks
      )?.field_template_title?.[0]?.value;
      const heroFormattedTitle = removeNbsp(
        stripHtml(
          findValueByKey('hero_graphic_block_type', item?.field_template_blocks)
            ?.field_formatted_title?.[0]?.value
        )
      );

      if (!templateTitle && !heroFormattedTitle) {
        return '';
      }

      return [
        truncateTextByItemCount(templateTitle),
        truncateTextByItemCount(heroFormattedTitle),
      ];
    });

    setTitles(titles);
  };

  useEffect(() => {
    truncate();
  }, [data]);

  const onChipClick = (event, category) => {
    // if (typeof window !== "undefined") {
    //     localStorage.setItem('name', category[0]['name'])

    //     if(window.location.pathname !== '/resources'){
    //         router.push('/resources');
    //     }
    // }

    if (typeof window !== 'undefined') {
      // localStorage.setItem('name', category[0]['name'])
      if (window.location.pathname !== '/resources') {
        // router.push('/resources');
        router.push({
          pathname: '/resources',
          query: { category: category[0]['name'].toLowerCase() },
        });
      }
    }
  };

  const onViewAll = (event, categories) => {
    if (typeof window !== 'undefined') {
      if (!categories[0]) {
        return;
      }

      localStorage.setItem('name', categories[0]);

      if (window.location.pathname !== '/resources') {
        router.push('/resources');
      }
    }
  };

  const truncateTextByItemCount = (value) => {
    if (!value) {
      return;
    }

    let truncation;

    if (data.length == 1) {
      truncation = applyTruncationForScreen(value, 60, 60, 60, 60);
    } else if (data.length == 2) {
      truncation = applyTruncationForScreen(value, 82, 60, 60, 60);
    } else if (data.length == 3) {
      truncation = applyTruncationForScreen(value, 55, 60, 60, 60);
    } else if (data.length == 4) {
      truncation = applyTruncationForAllScreen(value, 55, 43, 45, 18, 32, 37);
    }
    return truncation;
  };

  const renderRelated = () => {
    if (!data.length) {
      return;
    }

    return data.map((item, index) => {
      return (
        <a
          key={'related-key-' + index}
          className={'div-related-content-link item'}
          // onClick={(event) => {
          //   if (!item['url-alias']) {
          //     return;
          //   }
          //
          //   event.stopPropagation();
          //   if (isLinkAbsolute(item['url-alias'])) {
          //     window.open(item['url-alias'], '_blank');
          //   } else {
          //     router.push(item['url-alias']);
          //   }
          // }}
          href={item['url-alias']}
          target={isLinkAbsolute(item['url-alias']) ? '_blank' : '_self'}
        >
          <div className={'img-container'}>
            {getImage(
              findValueByKey(
                'template_banner_block_type',
                item?.field_template_blocks
              )?.field_template_banner_bynder?.webimage,
              findValueByKey(
                'template_banner_block_type',
                item?.field_template_blocks
              )?.field_web_small_image?.webimage,
              findValueByKey(
                'hero_graphic_block_type',
                item?.field_template_blocks
              )?.field_hero_image?.webimage
            ) ? (
              <Image
                objectFit="center"
                layout="fill"
                alt="template-related"
                src={getImage(
                  findValueByKey(
                    'template_banner_block_type',
                    item?.field_template_blocks
                  )?.field_template_banner_bynder?.webimage,
                  findValueByKey(
                    'template_banner_block_type',
                    item?.field_template_blocks
                  )?.field_web_small_image?.webimage,
                  findValueByKey(
                    'hero_graphic_block_type',
                    item?.field_template_blocks
                  )?.field_hero_image?.webimage
                )}
              />
            ) : (
              <img alt="placeholder" src={'/images/placeholder.png'} />
            )}
          </div>
          <div className={'category'}>
            <span className={'category'}>
              {item?.field_content_type_templat
                ? item?.field_content_type_templat[0]?.name
                : item?.field_page_type
                  ? item?.field_page_type[0]?.value
                  : ''}
            </span>
            <span>
              {item?.field_time_to_read !== undefined &&
              item?.field_time_to_read[0] !== undefined
                ? `, ${item?.field_time_to_read[0]?.value}`
                : ''}
            </span>
          </div>
          <span className={'title'}>
            {isItUndefined(item?.field_display_title)
              ? isItUndefined(item?.field_display_title)
              : titles[index]}
          </span>
          <span
            className={'span-related-content-link second-category'}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onChipClick(event, [
                {
                  name: item?.field_template_category
                    ? item?.field_template_category[0]?.name
                    : '',
                },
              ]);
            }}
          >
            {item?.field_template_category
              ? item?.field_template_category[0]?.name
              : item?.field_template_tertiary_category
                ? item?.field_template_tertiary_category[0]?.name
                : ''}
            {/* {item?.field_template_category ? item?.field_template_category[0]?.name : ''} */}
          </span>
        </a>
      );
    });
  };

  return (
    <>
      <div className={'related-block inner-container'}>
        <div className={'template-related container-length-' + data.length}>
          <div className={'top'}>
            {asPath == '/' || asPath?.includes('home-global-v2') ? (
              <h3
                className={`page-sub ${asPath == '/' || asPath?.includes('home-global-v2') ? 'home-global' : ''}`}
              >
                {title}
              </h3>
            ) : (
              <span className={'page-sub'}>{title}</span>
            )}
            {link?.length > 0 && link[0]?.title && (
              <a
                href="/resources"
                onClick={(e) => onViewAll(e, primaries)}
                className={`a-related-content-link cta-link`}
              >
                {link[0]?.title}
                <img
                  alt="arrow"
                  className="more-arrow"
                  src="/images/more-arrow.svg"
                />
              </a>
            )}
          </div>
          <hr />
          {isItUndefined(otherData.field_display_block) == '1' ? (
            <div className="related-wrapper">
              <div className="left-side">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getObjectValueByMachineName(
                      otherData?.field_description[0]?.value,
                      global
                    ),
                  }}
                  className={'description'}
                />
                {otherData?.field_cta_bar_button_selection?.length > 0 ? (
                  <CtaBarButton
                    blockTypeClass={'template-related'}
                    setMarketoTrigger={setMarketoTrigger}
                    data={
                      otherData?.field_cta_bar_button_selection[0]
                        ?.cta_bar_button
                    }
                    pathname={true}
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="right-side">
                <a
                  target={
                    isLinkAbsolute(
                      otherData?.field_featured_content_link?.[0]?.value
                    )
                      ? '_blank'
                      : '_self'
                  }
                  href={otherData?.field_featured_content_link?.[0]?.value}
                >
                  <div
                    className={`image-wrapper ${otherData?.field_featured_content_link?.[0]?.value ? 'hover-pointer' : ''} `}
                  >
                    <div
                      className="bg-image"
                      style={{
                        backgroundImage: `url('${Constants.cloudinaryImage + otherData.field_image.webimage}')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                      }}
                    />
                    <div className="overlay" />
                    <div className="logo-overlay">
                      {otherData.field_template_logo.webimage ? (
                        <Image
                          src={otherData.field_template_logo.webimage}
                          width={160}
                          height={60}
                          alt="Logo"
                        />
                      ) : null}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          ) : null}
          <div className={data.length ? `items items-${data.length}` : 'items'}>
            {renderRelated()}
          </div>
        </div>
      </div>
      {marketoTrigger && (
        <FacilityModal global={global} lang={lang}>
          {
            otherData?.field_cta_bar_button_selection[0]?.cta_bar_button
              ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
          }
        </FacilityModal>
      )}
    </>
  );
}
